module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"HomePage":"Главная","My Account":"Мой профиль","Tutorial":"Вводный курс","Sign out":"Выход","Add":"Внести"}}')
  delete Component.options._Ctor
}
